import { Link } from 'react-router-dom';

interface BreadcrumbItem {
  name: string;
  url: string;
}

interface BreadcrumbProps {
  items: BreadcrumbItem[];
}

export default function Breadcrumb({ items }: BreadcrumbProps) {
  return (
    <nav aria-label="Breadcrumb" className="py-4">
      <ol className="flex items-center space-x-2 text-sm">
        <li>
          <Link
            to="/"
            className="text-gray-500 hover:text-orange-500 transition-colors flex items-center cursor-pointer"
          >
            <i className="ri-home-4-line mr-1"></i>
            Início
          </Link>
        </li>
        {items.map((item, index) => (
          <li key={index} className="flex items-center">
            <i className="ri-arrow-right-s-line text-gray-400 mx-1"></i>
            {index === items.length - 1 ? (
              <span className="text-gray-700 font-medium">{item.name}</span>
            ) : (
              <Link
                to={item.url}
                className="text-gray-500 hover:text-orange-500 transition-colors cursor-pointer"
              >
                {item.name}
              </Link>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
}
